import React from 'react';

export function CircularProgressSmall(props) {
    return (
        <div style={{overflow: 'visible', transform: 'scale(0.5,0.5)', height: '0', width: '40px'}}>
            <div className="preloader-wrapper active">
                <div className={"spinner-layer spinner-" + (props.color || 'primary') + "-only"}>
                    <div className="circle-clipper left">
                        <div className="circle"></div>
                    </div><div className="gap-patch">
                        <div className="circle"></div>
                    </div><div className="circle-clipper right">
                        <div className="circle"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function CircularProgress(props) {
    return (
        <div style={{overflow: 'hidden'}}>
            <div className="preloader-wrapper active">
                <div className={"spinner-layer spinner-" + (props.color || 'primary') + "-only"}>
                    <div className="circle-clipper left">
                        <div className="circle"></div>
                    </div><div className="gap-patch">
                        <div className="circle"></div>
                    </div><div className="circle-clipper right">
                        <div className="circle"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const PercentageLoadingCircle = ({ pctDone, strokeWidth=1.5, bcgColor='#22222222', successColor='#4CAF50' }) => {

    return (
        <svg viewBox="0 0 36 36" style={{ width: '100%', display: 'inline-block', maxWidth: '200px', height: 'auto'}}>
            <path stroke={bcgColor} strokeWidth={strokeWidth} fill="none" d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"></path>
            <path strokeDasharray={`${pctDone}, 100`} stroke={successColor} strokeWidth={strokeWidth} fill="none" strokeLinecap='round' d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"></path>
            <text x="18" y="18" className="pct-circle-text" dominantBaseline={'middle'}>{pctDone}%</text>
        </svg>
    )
}